import Vue from 'vue';
import {VueMasonryPlugin} from 'vue-masonry';

import Hero from '../blocks/Hero/Hero.vue';
import Menu from '../elements/Menu.vue';

import PortalVue from 'portal-vue';
import NewsletterForm from '../blocks/NewsletterForm/NewsletterForm.vue';
import HorizontalTicketList from '../elements/horizontal-ticket-list/HorizontalTicketList.vue';
import HeaderSearch from '../elements/header-search/HeaderSearch.vue';
import VScrollLock from 'v-scroll-lock';
import Gallery from '../elements/gallery/Gallery.vue';
import Reviews from '../elements/reviews/Reviews.vue';
import Comments from '../elements/comments/Comments.vue';

Vue.use(VScrollLock, {
  bodyScrollOptions: {
    reserveScrollBarGap: true,
  },
});
Vue.use(PortalVue);
Vue.use(VueMasonryPlugin);

const initVue = () => {
  let nodes = document.querySelectorAll('.js-vue');
  for (let node of nodes) {
    new Vue({
      el: node,
      components: {
        'lillan-hero': Hero,
        'lillan-menu': Menu,
        'lillan-newsletter-form': NewsletterForm,
        'lillan-horizontal-ticket-list': HorizontalTicketList,
        'lillan-search': HeaderSearch,
        'lillan-gallery': Gallery,
        'lillan-reviews': Reviews,
        'lillan-comments': Comments,
      },
    });
  }
};

window.addEventListener('DOMContentLoaded', () => {
  initVue();

  window.acf && window.acf.addAction('render_block_preview', () => {
    initVue();
  });

});

